import React from "react";
import { Helmet } from "react-helmet";

import { ArtistsShowcase } from "../components/common/ArtistsShowcase/ArtistsShowcase";

import G1 from "../assets/images/artists/a-1.png";
import G2 from "../assets/images/artists/a-2.png";
import G3 from "../assets/images/artists/a-3.png";
import G4 from "../assets/images/artists/a-4.png";
import G5 from "../assets/images/artists/a-5.png";
import G7 from "../assets/images/artists/a-7.png";
import G8 from "../assets/images/artists/a-8.png";
import G9 from "../assets/images/artists/a-9.png";
import G11 from "../assets/images/artists/a-11.png";
import G12 from "../assets/images/artists/a-12.png";
import G13 from "../assets/images/artists/a-13.png";
import G14 from "../assets/images/artists/a-14.png";
// import G15 from "../assets/images/artists/a-15.png";
import G16 from "../assets/images/artists/a-16.png";
import G17 from "../assets/images/artists/a-17.png";
import G18 from "../assets/images/artists/a-18.png";

const Artists = () => {
  const artists = [
    { name: "Morpho", image: G1 },
    { name: "Raid", image: G2 },
    { name: "Für Elise", image: G3 },
    { name: "Diib", image: G4 },
    { name: "Loun", image: G5 },
    { name: "Youss45", image: G7 },
    { name: "21 Tach", image: G8 },
    { name: "x7Kira", image: G9 },
    { name: "JNTYY", image: G11 },
    { name: "Aessa", image: G12 },
    { name: "LMLTM", image: G13 },
    { name: "Only", image: G14 },
    // { name: "Artist 13", image: G15 },
    { name: "Astro", image: G16 },
    { name: "Em", image: G17 },
    { name: "21 Tach", image: G18 },
  ];

  return (
    <>
      <Helmet>
        <title>Artists — Lembawe9 / LHANGAR</title>

        <meta
          name="description"
          content="Discover the artists who have been part of LHANGAR and the wider Lembawe9 creative movement."
        />
      </Helmet>

      <main>
        <ArtistsShowcase
          artists={artists}
        />
      </main>
    </>
  );
};

export default Artists;